import type { GetServerSideProps } from 'next'
import Head from 'next/head'
import { Post } from '@api/types'
import MainLayout from '@ui/components/main-layout'
import LoadingContainer from '@ui/components/loading-container'
import PostDetail from '@ui/components/post-detail'
import PostOpenGraph from '@ui/components/post-open-graph'
import { viralService } from '@api/viral'

const PostDetailPage = ({ post }: { post: Post }) => {
  return (
    <MainLayout title='Old Row Viral'>
      <Head>
        <PostOpenGraph post={post} />
      </Head>
      {post ? <PostDetail post={post} /> : <LoadingContainer isLoading={true} />}
    </MainLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const id = query.id as string
  const post = await viralService.read(id)
  return {
    props: {
      post
    }
  }
}

export default PostDetailPage
